import {
  Filter,
  InvoicesModeFilter,
  InvoicesProductFilter,
  InvoicesShipToFilter,
  InvoicesSalesTermsFilter,
  ShipDateFilter,
  InvoiceDateFilter,
  InvoicesDueDateFilter,
} from "components/Filters";

const invoicesFilters: Filter[] = [
  { key: "invoiceDate", component: InvoiceDateFilter },
  { key: "dueDate", component: InvoicesDueDateFilter },
  { key: "product", component: InvoicesProductFilter },
  { key: "shipDate", component: ShipDateFilter },
  { key: "shipTo", component: InvoicesShipToFilter },
  { key: "mode", component: InvoicesModeFilter },
  { key: "saleTerms", component: InvoicesSalesTermsFilter },
];

export default invoicesFilters;
